'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createEagerFactory = require('recompose/createEagerFactory');

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _pick = require('lodash/fp/pick');

var _pick2 = _interopRequireDefault(_pick);

var _isArray = require('lodash/fp/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getMapper(arg) {
  if (typeof arg === 'function') return arg;
  if ((0, _isArray2.default)(arg)) return (0, _pick2.default)(arg);
  return (0, _pick2.default)(Object.keys(arg));
}

function injectOuterProps(arg, willConsume) {
  var mapper = getMapper(arg);

  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var Inject = function (_React$Component) {
      _inherits(Inject, _React$Component);

      function Inject(props, context) {
        _classCallCheck(this, Inject);

        var _this = _possibleConstructorReturn(this, (Inject.__proto__ || Object.getPrototypeOf(Inject)).call(this, props, context));

        if (willConsume) {
          var _selectScope = (0, _utils.selectScope)(_this.context),
              outerProps = _selectScope.outerProps,
              addToConsuming = _selectScope.addToConsuming;

          Object.keys(mapper(outerProps)).map(addToConsuming);
        }
        return _this;
      }

      _createClass(Inject, [{
        key: 'render',
        value: function render() {
          var scope = (0, _utils.selectScope)(this.context);

          return factory(_extends({}, mapper(scope.outerProps), this.props));
        }
      }]);

      return Inject;
    }(_react2.default.Component);

    Inject.contextTypes = _utils.scopeContextTypes;

    return Inject;
  };
}

exports.default = injectOuterProps;


//////////////////
// WEBPACK FOOTER
// ./~/recompose-scope/injectOuterProps.js
// module id = 1120
// module chunks = 0